export const CATEGORY_GROUPS: Record<string, string[]> = {
  beauty: [
    "cosmetics",
    "skin care",
    "other beauty",
    "accessories-beauty",
    "bundles-cosmetics",
    "bundles-other beauty",
    "bundles-skin care",
    "cleanser",
    "cosmetics-other",
    "devices-skin care",
    "eye cosmetics",
    "face cosmetics",
    "lip cosmetics",
    "mask",
    "moisturizer",
    "selling support-beauty",
    "toner",
    "treatment",
    "undefined-other beauty",
    "undefined-skin care",
  ],
};

export const tabs = [
  { viewId: 1, label: "All" },
  { viewId: 2, label: "Beauty" },
  { viewId: 3, label: "Catalog" },
  { viewId: 4, label: "Durables" },
  { viewId: 5, label: "Home Care" },
  { viewId: 6, label: "Nutrition" },
  { viewId: 7, label: "Personal Care" },
  { viewId: 8, label: "Other" },
  { viewId: 9, label: "Unknown" },
];

export const yearlyTabs = [
  { viewId: 1, label: "Beauty" },
  { viewId: 2, label: "Catalog" },
  { viewId: 3, label: "Durables" },
  { viewId: 4, label: "Home Care" },
  { viewId: 5, label: "Nutrition" },
  { viewId: 6, label: "Personal Care" },
  { viewId: 7, label: "Other" },
  { viewId: 8, label: "Unknown" },
];

export const THEME_STYLE = {
  light: {
    axis: "#555",
    grid: "#E0E0E0",
    tooltipBg: "#fff",
    tooltipText: "#000",
    pillText: "#2c2c2c",
    pillBorder: "#ccc",
  },
  dark: {
    axis: "#BFBFBF",
    grid: "#444",
    tooltipBg: "#1F1F1F",
    tooltipText: "#fff",
    pillText: "#D8D8D9",
    pillBorder: "#555",
  },
};

export type Theme = "light" | "dark";

export const ALL_PILL_COLOR: Record<Theme, string> = {
  light: "#1677FF",
  dark: "#69B1FF",
};

export const CATEGORY_COLORS: Record<Theme, string[]> = {
  light: [
    "#99B2F5",
    "#F16A81",
    "#77CBBF",
    "#667DBB",
    "#B2F9FF",
    "#AF60B1",
    "#77CBBF",
    "#F5A066",
    "#CE4800",
  ],
  dark: [
    "#5969D6",
    "#F3596C",
    "#396E75",
    "#38539A",
    "#05A896",
    "#7E3E80",
    "#396E75",
    "#F5A066",
    "#EF6D46",
  ],
};
